import { useQuery } from "@tanstack/react-query"
import { customerQuery, CustomerQueryOptions } from "../lib/customerQuery"

export function useCustomerQuery({ id, ...rest }: { id: string } & CustomerQueryOptions) {
  return useQuery(customerQuery(id, rest))
}
